import type { SchemaBuilderFieldRowProps } from "./schema-builder-field-row.type";
import type { SchemaField } from "@/entities/schema";

import classNames from "classnames";
import { useState } from "react";

import { isSchemaFieldSeveritySection } from "@/entities/schema";

import {
  SchemaBuilderDndHandle,
  SchemaBuilderDndWrapper,
} from "../schema-builder-dnd";
import { SchemaBuilderFieldProvider } from "../schema-builder-field";
import { SchemaBuilderFieldActions } from "../schema-builder-field-actions";
import { SchemaBuilderFieldEditor } from "../schema-builder-field-editor";
import { SchemaBuilderFieldFlags } from "../schema-builder-field-flags";
import { SchemaBuilderFieldIcon } from "../schema-builder-field-icon";
import { SchemaBuilderFieldTitle } from "../schema-builder-field-title";
import { SchemaBuilderFieldTypeName } from "../schema-builder-field-type";
import { isNewSchemaField } from "../schema-builder.helper";

import "./schema-builder-field-row.style.less";

export const SchemaBuilderFieldRow = ({
  schema,
  isActive,
  isDragged,
  onFieldUpdate,
  onCopyClick,
  onDeleteClick,
  dndProperties,
}: SchemaBuilderFieldRowProps) => {
  const isNewField = isNewSchemaField(schema);
  const isSeverityField = isSchemaFieldSeveritySection(schema);

  const [showEditor, setShowEditor] = useState<boolean>(isNewField);
  const toggleEditor = () => setShowEditor((value) => !value);

  const onFieldDataUpdate = (schema: SchemaField) => {
    setShowEditor(false);
    onFieldUpdate?.(schema);
  };

  return (
    <SchemaBuilderFieldProvider schema={schema}>
      <SchemaBuilderDndWrapper
        className={classNames("schema-builder-field-row", {
          "-active": isActive,
          "-dragged": isDragged,
        })}
      >
        <div className="schema-builder-field-row-preview">
          <div className="schema-builder-field-row-preview-left">
            {!isSeverityField && <SchemaBuilderDndHandle {...dndProperties} />}
            <SchemaBuilderFieldIcon schema={schema} />
            <SchemaBuilderFieldTypeName schema={schema} />
          </div>

          {!isDragged && <SchemaBuilderFieldTitle schema={schema} />}

          <div className="schema-builder-field-row-preview-right">
            <SchemaBuilderFieldFlags schema={schema} />
            <SchemaBuilderFieldActions
              schema={schema}
              onPreviewClick={toggleEditor}
              onEditClick={toggleEditor}
              onCopyClick={onCopyClick}
              onDeleteClick={onDeleteClick}
            />
          </div>
        </div>

        {showEditor && (
          <SchemaBuilderFieldEditor
            schema={schema}
            onFieldUpdate={onFieldDataUpdate}
          />
        )}
      </SchemaBuilderDndWrapper>
    </SchemaBuilderFieldProvider>
  );
};
